import React from 'react';
import { Divider } from '@stockx/ui';
import { useTranslation } from 'react-i18next';
import { Date } from '@app/datetime';

const ReleaseDate = ({ product }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const firstDateFormat = language === 'it' ? 'day_of_month' : 'month_short';
  const secondDateFormat = language === 'it' ? 'month_short' : 'day_of_month';

  const restReleastDate = product.releaseDate;
  const graphqlReleaseDate = product?.traits?.find(
    (trait) => trait?.name === 'Release Date',
  )?.value;

  return (
    <span>
      <Date
        date={restReleastDate || graphqlReleaseDate}
        format={firstDateFormat}
        considerTimeZone={false}
      />
      <Divider
        orientation="vertical"
        display="inline-block"
        borderLeftWidth="2px"
        borderColor="neutral.400"
        h="19px"
        opacity="1"
        position="relative"
        top="2px"
        mx={2}
      />
      <Date
        date={restReleastDate || graphqlReleaseDate}
        format={secondDateFormat}
        considerTimeZone={false}
      />
    </span>
  );
};

export default ReleaseDate;
